import { useCallback, useEffect, useMemo, useState } from 'react';
import { refills as api } from '../api-client/index';
export function useRefills() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await api.list();
            setEvents(data);
        }
        catch (e) {
            setError('Failed to load refills');
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        void load();
    }, [load]);
    const eventsByDateDesc = useMemo(() => {
        return [...events].sort((a, b) => {
            if (a.date === b.date)
                return a.createdAt < b.createdAt ? 1 : -1;
            return a.date < b.date ? 1 : -1;
        });
    }, [events]);
    const create = useCallback(async (blocks, date) => {
        const event = await api.create(blocks, date);
        setEvents(prev => [event, ...prev]);
        return event;
    }, []);
    const remove = useCallback(async (id) => {
        await api.remove(id);
        setEvents(prev => prev.filter(e => e.id !== id));
    }, []);
    return { events, eventsByDateDesc, loading, error, load, create, remove };
}
